// Footer pages. Content is placeholder and freely editable here.
// Each page: slug, path, localized title and body paragraphs (it/en/es).
export const SITE_PAGES = [
  {
    slug: "cookie",
    path: "/cookie",
    title: { it: "Informativa sui cookie", en: "Cookie Policy", es: "Política de cookies" },
    body: {
      it: [
        "Questa è una pagina segnaposto per l'Informativa sui cookie di Canarias Market.",
        "Descrivi qui quali cookie utilizzi (tecnici, analitici, di marketing), le loro finalità e come l'utente può gestirli o disabilitarli.",
        "Sostituisci questo testo con la tua informativa definitiva.",
      ],
      en: [
        "This is a placeholder page for the Canarias Market Cookie Policy.",
        "Describe here which cookies you use (technical, analytics, marketing), their purposes and how users can manage or disable them.",
        "Replace this text with your final policy.",
      ],
      es: [
        "Esta es una página de marcador de posición para la Política de cookies de Canarias Market.",
        "Describe aquí qué cookies utilizas (técnicas, analíticas, de marketing), sus finalidades y cómo el usuario puede gestionarlas o desactivarlas.",
        "Sustituye este texto por tu política definitiva.",
      ],
    },
  },
  {
    slug: "privacy",
    path: "/privacy",
    title: { it: "Privacy Policy", en: "Privacy Policy", es: "Política de privacidad" },
    body: {
      it: [
        "Questa è una pagina segnaposto per la Privacy Policy di Canarias Market.",
        "Spiega quali dati personali raccogli, come li usi e li proteggi, la base giuridica del trattamento e i diritti dell'utente (accesso, rettifica, cancellazione).",
        "Sostituisci questo testo con la tua informativa definitiva.",
      ],
      en: [
        "This is a placeholder page for the Canarias Market Privacy Policy.",
        "Explain which personal data you collect, how you use and protect it, the legal basis for processing and the user's rights (access, rectification, erasure).",
        "Replace this text with your final policy.",
      ],
      es: [
        "Esta es una página de marcador de posición para la Política de privacidad de Canarias Market.",
        "Explica qué datos personales recoges, cómo los usas y proteges, la base jurídica del tratamiento y los derechos del usuario (acceso, rectificación, supresión).",
        "Sustituye este texto por tu política definitiva.",
      ],
    },
  },
  {
    slug: "piattaforma",
    path: "/la-nostra-piattaforma",
    title: { it: "La nostra piattaforma", en: "Our platform", es: "Nuestra plataforma" },
    body: {
      it: [
        "Canarias Market è il marketplace locale delle Isole Canarie: compra e vendi prodotti di seconda mano e scopri attività e servizi verificati.",
        "Questa è una pagina segnaposto: racconta qui la missione, i valori e come funziona la piattaforma.",
        "Sostituisci questo testo con i tuoi contenuti definitivi.",
      ],
      en: [
        "Canarias Market is the local marketplace of the Canary Islands: buy and sell second-hand items and discover verified activities and services.",
        "This is a placeholder page: tell your mission, values and how the platform works here.",
        "Replace this text with your final content.",
      ],
      es: [
        "Canarias Market es el marketplace local de las Islas Canarias: compra y vende artículos de segunda mano y descubre actividades y servicios verificados.",
        "Esta es una página de marcador de posición: cuenta aquí tu misión, valores y cómo funciona la plataforma.",
        "Sustituye este texto por tu contenido definitivo.",
      ],
    },
  },
  {
    slug: "termini",
    path: "/termini-e-condizioni",
    title: { it: "Termini e condizioni", en: "Terms & Conditions", es: "Términos y condiciones" },
    body: {
      it: [
        "Questa è una pagina segnaposto per i Termini e condizioni di Canarias Market.",
        "Definisci qui le regole d'uso della piattaforma, i diritti e doveri di acquirenti e venditori, le responsabilità e le limitazioni.",
        "Sostituisci questo testo con i tuoi termini definitivi.",
      ],
      en: [
        "This is a placeholder page for the Canarias Market Terms & Conditions.",
        "Define here the platform usage rules, the rights and duties of buyers and sellers, liabilities and limitations.",
        "Replace this text with your final terms.",
      ],
      es: [
        "Esta es una página de marcador de posición para los Términos y condiciones de Canarias Market.",
        "Define aquí las reglas de uso de la plataforma, los derechos y deberes de compradores y vendedores, las responsabilidades y limitaciones.",
        "Sustituye este texto por tus términos definitivos.",
      ],
    },
  },
  {
    slug: "termini-business",
    path: "/termini-e-condizioni-business",
    title: { it: "Termini e condizioni Business", en: "Business Terms & Conditions", es: "Términos y condiciones Business" },
    body: {
      it: [
        "Questa è una pagina segnaposto per i Termini e condizioni Business di Canarias Market.",
        "Definisci qui le condizioni specifiche per i profili professionali: abbonamenti, fatturazione, obblighi e directory dei servizi.",
        "Sostituisci questo testo con i tuoi termini definitivi.",
      ],
      en: [
        "This is a placeholder page for the Canarias Market Business Terms & Conditions.",
        "Define here the specific conditions for professional profiles: subscriptions, billing, obligations and the services directory.",
        "Replace this text with your final terms.",
      ],
      es: [
        "Esta es una página de marcador de posición para los Términos y condiciones Business de Canarias Market.",
        "Define aquí las condiciones específicas para los perfiles profesionales: suscripciones, facturación, obligaciones y el directorio de servicios.",
        "Sustituye este texto por tus términos definitivos.",
      ],
    },
  },
];

export const pageBySlug = (slug) => SITE_PAGES.find((p) => p.slug === slug);
